import StyledDrawer from 'Components/StyledDrawer'
import { useIsPtaBannerVisible } from 'Services/common/Features/Authority/Context/utils'
import useTypedSelector from 'Store'
import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

interface DynamicDrawerMenuProps {
  drawerMenuContent: ReactNode
}

function DynamicDrawerMenu({ drawerMenuContent }: Readonly<DynamicDrawerMenuProps>) {
  const { user } = useTypedSelector(state => state.user)
  const location = useLocation()
  const isPtaBannerVisible = useIsPtaBannerVisible(user, location)
  return (
    <StyledDrawer isPtaBannerVisible={isPtaBannerVisible} variant="permanent" open={true}>
      {drawerMenuContent}
    </StyledDrawer>
  )
}

export { DynamicDrawerMenu }
